const EPIC_BASE_URL = import.meta.env.VITE_EPIC_BASE_URL;

export const getEpicAccountURL = (epicAccountUuid: string | undefined) => {
  if (!epicAccountUuid || !EPIC_BASE_URL) {
    return undefined;
  }
  return `${EPIC_BASE_URL}/#/epic/account/${epicAccountUuid}/policies`;
};

export const getEpicPolicyURL = (epicPolicyUuid: string | undefined) => {
  if (!epicPolicyUuid || !EPIC_BASE_URL) {
    return undefined;
  }
  return `${EPIC_BASE_URL}/#/epic/policy/${epicPolicyUuid}`;
};
